import { Injectable, inject } from '@angular/core';
import {
    Storage,
    ref,
    getStorage,
    uploadString,
    getDownloadURL,
    deleteObject,
} from '@angular/fire/storage';

@Injectable({
    providedIn: 'root',
})
export class UploadService {
    private readonly storage: Storage = inject(Storage);

    async uploadFileFromBase64(
        dataUrl: string,
        filePath: string
    ): Promise<string> {
        const imageStorageRef = ref(getStorage(), filePath);

        await uploadString(imageStorageRef, dataUrl, 'base64');

        const imageStorageDownloadURL = await getDownloadURL(imageStorageRef);

        
        return imageStorageDownloadURL;
    }


    async deleteFile(fileUrl: string): Promise<void> {
        try {
            const fileRef = ref(this.storage, fileUrl);
            await deleteObject(fileRef);
        }
        catch (error)
        {
            console.error('Error eliminando archivo:', error);
        }
    }
}
